<template>
  <div>Xuất file Excel theo mẫu của Sở</div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import ExcelJS from 'exceljs'
import moment from 'moment'

const EXCEL_TEMPLATE_PATH = '/mark-export-template.xlsx'

const fetchFileAsBuffer = async path => {
  const response = await fetch(path)
  if (!response.ok) throw new Error(`Failed to fetch file. Status: ${response.status}`)
  return response.arrayBuffer()
}

export default {
  props: { query: { type: Object, default: () => {} }, studentMarks: Array, factors: Array },
  data: () => ({ list: [], factorsRaw: [] }),
  methods: {
    async processTemplate() {
      try {
        // Step 1: Fetch the File from the server
        const buffer = await fetchFileAsBuffer(EXCEL_TEMPLATE_PATH)

        // Step 2: Load the Workbook
        const workbook = new ExcelJS.Workbook()
        await workbook.xlsx.load(buffer)

        // Step 3: Modify the Workbook (Same logic as before)
        await this.modifyWorkbook(workbook)

        // Step 4: Export the Modified Workbook
        await this.onDownload(workbook)
      } catch (error) {
        console.error('Error processing Excel file:', error)
      }
    },
    async modifyWorkbook(workbook) {
      const info = this.getInfo()
      const worksheet = workbook.worksheets[0]
      const rowInfo = worksheet.getRow(4)
      rowInfo.getCell(1).value = `Lớp: ${info.className}`
      rowInfo.getCell(4).value = `Môn học: ${info.subjectGroup} - GV: Quản trị đơn vị`

      const data = await this.getData()
      if (data.length < 34) {
        const diff = 34 - data.length
        for (let i = 0; i < diff; i++) data.push(Array(11).fill(''))
      }
      worksheet.spliceRows(9, 35, ...data)
    },

    getShortTitle(type = '') {
      switch (type) {
        case 'factor-1':
          return 'ĐĐGtx'
        case 'factor-2':
          return 'ĐĐGgk'
        case 'factor-3':
          return 'ĐĐGck'
        default:
          return ''
      }
    },
    async getData() {
      const res = []
      const factorsRaw = Object.values(this.factors).map(v => ({ ...v, short_title: this.getShortTitle(v.type) }))
      const studentMarks = this.studentMarks
      const isEvaluate = get(this.query, 'subject.markType') === 'evaluate'
      if (Array.isArray(studentMarks) && studentMarks.length) {
        studentMarks.forEach((item, index) => {
          const tmp = []
          tmp.push(
            index + 1,
            get(item, 'student.code'),
            get(item, 'student.name'),
            moment(get(item, 'student.dob')).format('DD/MM/YYYY')
          )
          const allMarks = get(item, 'marks', [])
          factorsRaw.forEach(factor => {
            const marks = allMarks.filter(m => get(m, 'factor.id') === factor.id)
            if (factor.multiply === 1) {
              for (let i = 0; i < 5; i++) {
                tmp.push(this.getMarkValue({ mark: get(marks, `${i}`, {}), isEvaluate }))
              }
            } else {
              tmp.push(this.getMarkValue({ mark: get(marks, '0', {}), isEvaluate }))
            }
          })
          res.push(tmp)
        })
      }
      return res
    },

    getInfo() {
      const className = get(this.query, 'class.title', '')
      const schoolYear = get(this.query, 'semester.schoolYear.description', '')
      const semester = get(this.query, 'semester.title', '')
      const subject = get(this.query, 'subject.title', '')
      const subjectGroup = get(this.query, 'subject.subjectGroup.title', '')
      return { className, schoolYear, semester, subject, subjectGroup }
    },

    getMarkValue({ mark = {}, isEvaluate = false }) {
      let markValue = ''
      if (!isEvaluate) markValue = get(mark, 'value', '')
      else {
        const meaning = this.$options.filters.getEvaluate(mark.value)
        if (meaning !== '---') markValue = meaning
      }
      return markValue
    },

    async onDownload(workbook) {
      const { className, semester, subjectGroup } = this.getInfo()
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `Bảng điểm ${subjectGroup} lớp ${className} ${semester}.xlsx`
      link.click()
      this.$emit('onExportSuccess')
    }
  }
}
</script>
